// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3ffxN","paramInput":"JobSimulator_paramInput__1Dr9o","input":"JobSimulator_input__10uVA"};